export const HOME_PAGE = '/investment-calculator';
export const OPEN_END_FUND_ANALYSIS = '/';
export const BLOG = '/blog';
